(() => {
  'use strict';

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-pp-cookie-preferences]');
    if (!link || !window.privacyBanner?.showPreferences) return;
    event.preventDefault();
    window.privacyBanner.showPreferences().catch(() => {
      window.location.href = link.href;
    });
  });

  if (!window.Shopify?.loadFeatures) return;
  window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
    if (error || !window.Shopify.customerPrivacy) return;
    const privacy = window.Shopify.customerPrivacy;
    const canLoad = () => privacy.analyticsProcessingAllowed()
      && privacy.marketingAllowed() && privacy.saleOfDataAllowed();
    const allowedOnLoad = canLoad();

    document.addEventListener('visitorConsentCollected', () => {
      if (canLoad() !== allowedOnLoad) {
        if (allowedOnLoad) {
          consent('consent', 'update', {
            analytics_storage: 'denied',
            ad_storage: 'denied',
            ad_user_data: 'denied',
            ad_personalization: 'denied'
          });
        }
        // Reload drops the old tracking context and avoids replaying pre-consent events.
        window.location.reload();
      }
    });

    if (!allowedOnLoad) return;
    window.dataLayer = window.dataLayer || [];
    function consent() { window.dataLayer.push(arguments); }
    consent('consent', 'default', {
      analytics_storage: 'granted',
      ad_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted'
    });
    window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-NRS9KSXT';
    document.head.appendChild(script);
  });
})();
